module.exports = __webpack_public_path__ + "static/media/backArrowInactive.25cdb113.svg";